// Mount-once side-effects that should run for any authenticated user,
// across every route. Right now this is just the background territory
// tracker, but more "global services" can plug in here over time.

import { useAuth } from "@/auth/AuthContext";
import useBackgroundTerritory from "@/hooks/useBackgroundTerritory";

export default function BackgroundServices() {
    const { user } = useAuth();
    // Tracker is enabled only once we have an authenticated user — no
    // point asking iOS for "Always" location when nobody's logged in.
    useBackgroundTerritory(!!user?.id);
    return null;
}
